import { render } from "./Styleguide-CustomRouteType.vue?vue&type=template&id=520126b3"
import script from "./Styleguide-CustomRouteType.vue?vue&type=script&lang=js"
export * from "./Styleguide-CustomRouteType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__